import React, { useState, useEffect } from 'react'
import './Toast.css'

let toastId = 0

const Toast = ({ message, type = 'info', duration = 3000, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose()
    }, duration)

    return () => clearTimeout(timer)
  }, [duration, onClose])

  return (
    <div className={`toast toast-${type}`}>
      <span className="toast-message">{message}</span>
      <button className="toast-close" onClick={onClose}>
        ×
      </button>
    </div>
  )
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState([])

  const addToast = (message, type = 'info', duration = 3000) => {
    const id = toastId++
    const newToast = { id, message, type, duration }

    setToasts(prevToasts => [...prevToasts, newToast])

    return id
  }

  const removeToast = (id) => {
    setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id))
  }

  // Make addToast globally available
  window.showToast = addToast

  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  )
}

// Export convenience functions
export const showToast = (message, type = 'info', duration = 3000) => {
  if (window.showToast) {
    return window.showToast(message, type, duration)
  }
}

export const showSuccess = (message, duration = 3000) => showToast(message, 'success', duration)
export const showError = (message, duration = 4000) => showToast(message, 'error', duration)
export const showInfo = (message, duration = 3000) => showToast(message, 'info', duration)